import React from 'react';
import styles from './styles.module.scss';

const Paginacao = ({ maxPage, page, setPage }) => {
  const proximo = () => {
    setPage(page + 1);
  };
  const anterior = () => {
    setPage(page - 1);
  };

  return (
    <div className={styles.wrapper}>
      {page - 1 > 0 && (
        <>
          <button className={styles.button} onClick={anterior}>
            Anterior
          </button>
          <button className={styles.button} onClick={anterior}>
            {page - 1}
          </button>
        </>
      )}
      <button className={`${styles.active}`}>{page}</button>
      {page + 1 <= maxPage && (
        <>
          <button className={styles.button} onClick={proximo}>
            {page + 1}
          </button>
          <button className={styles.button} onClick={proximo}>
            Próximo
          </button>
        </>
      )}
    </div>
  );
};

export default Paginacao;
